/* eslint-disable valid-jsdoc */
import chunk from 'lodash/chunk';
import { CONST_FILE_UPLOAD } from '../../config/constants';
import { getMaxItemsPerChunk } from '../features/selectors';
import { TYPE_CHAPS } from '../../config';

const {
	MAX_ITEMS_PER_CHUNK_FPS,
	MAX_ITEMS_PER_CHUNK_CHAPS,
	MAX_ITEMS_PER_CHUNK_BENEFICIARY,
	MAX_ITEMS_PER_CHUNK_SCHEDULED_PAYMENTS,
} = CONST_FILE_UPLOAD;

export const START_BATCH_PROCESS = 'START_BATCH_PROCESS';
export const STOP_BATCH_PROCESS = 'STOP_BATCH_PROCESS';
export const UPDATE_BATCH_PROGRESS = 'UPDATE_BATCH_PROGRESS';

/**
 * @param {number} total Total number of chunks
 * @param {number} completed Completed number of chunks
 * @returns {import("redux").Action} Action
 */
export const updateBatchProgress = (completed, total) => ({
	type: UPDATE_BATCH_PROGRESS,
	payload: {
		completed,
		total,
	},
	meta: {
		allowedDuringApiCall: true,
	},
});

/**
 * @param {number} numberOfItems
 * @returns {import("redux").Action<{ numberOfItems: number }>} Action
 */
export const startBatchProcess = (numberOfItems) => ({
	type: START_BATCH_PROCESS,
	payload: {
		numberOfItems,
	},
});

/**
 * @returns {import("redux").Action} Action
 */
export const stopBatchProcess = () => ({
	type: STOP_BATCH_PROCESS,
});

const getPath = (category = '') => {
	switch (category) {
		case 'BENEFICIARY':
			return MAX_ITEMS_PER_CHUNK_BENEFICIARY;
		case TYPE_CHAPS:
			return MAX_ITEMS_PER_CHUNK_CHAPS;
		case 'SCHEDULED_PAYMENTS':
			return MAX_ITEMS_PER_CHUNK_SCHEDULED_PAYMENTS;
		default:
			return MAX_ITEMS_PER_CHUNK_FPS;
	}
};
const getChunks = (data = [], maxItemsPerChunk = 0) => chunk(data, maxItemsPerChunk);
const getTotalItems = (data = []) => data && data.length;
const getTotalChunks = (chunks = []) => chunks.length;
const getIsChunkingRequired = (totalChunks = 0) => totalChunks && totalChunks > 1;
const getChunkingDetails = [getTotalItems, getChunks, getTotalChunks, getIsChunkingRequired];

export const getChunkingInfo = (data = [], state, category = 'BENEFICIARY') => {
	const maxItemsPerChunk = getMaxItemsPerChunk(state, getPath(category));
	const totalItems = getChunkingDetails[0](data);
	const chunks = getChunkingDetails[1](data, maxItemsPerChunk);
	const totalChunks = getChunkingDetails[2](chunks);
	const isChunkingRequired = getChunkingDetails[3](totalChunks);

	return { totalItems, chunks, totalChunks, isChunkingRequired };
};
